module.exports = {"loadingText":"Načítavam konfiguračné údaje pre modul Portfolio","loadingGroupInfo":"Načítavam informácie o skupine"}